export interface InvitationToken {
  action: string;
  invitationId: number;
  isInviteeRegistered?: boolean;
}

export function transformToken(token: any): InvitationToken | undefined {
  if (token.action && token.invitation_id) {
    return {
      action: token.action,
      invitationId: token.invitation_id,
      isInviteeRegistered: token.is_invitee_registered,
    };
  }
}
